<template>
  <div class="pot__detail">
    <article class="pot h_fixed scroll__y" v-if="display">
      <header class="pot__head float_sdw wbox">
        <h1>{{pot.title}}</h1>
        <p class="desciption">{{description}}</p>
      </header>
      <div class="pot__content">
        <div class="pot__block">
          <p class="pot__action date">created at {{pot.created_at | formateFileDate}}</p>
        </div>
        <PotBlock v-for="(d, i) in details" :key="i"
        :d="d"
        @refresh="getPotDetail"
        @setMessage="setMessage"
        @deletePotDetail="deletePotDetail"
         />
      </div>
      <Postbox :mode="'single'" :id="pot.id"
      @refresh="getPotDetail"
      @setMessage="setMessage"
      />
    </article>
    <div class="pot__btm__box fx_ctr" v-if="Object.keys(pot).length > 0">
      <p v-if="message" class="pot__message">
        <span v-if="message.icon">
          <font-awesome-icon class="fa-spin" v-if="message.icon === 'spinner'" icon="spinner" />
          <font-awesome-icon v-else :icon="message.icon" />
        </span>
        {{message.message}}
      </p>
      <p v-else class="pot__message">last updated at {{pot.updated_at | formateFileDate}}</p>
      <ul class="pot__menu fx_ctr">
        <li v-show="pot.status !== 2" title="export pot with url" v-on:click="archivePot(pot.id, 2)"><font-awesome-icon icon="archive" /></li>
        <li v-show="pot.status === 2" title="export pot with url" v-on:click="archivePot(pot.id ,1)"><font-awesome-icon icon="folder-open" /></li>
        <li title="export pot with url" v-on:click="linkmenu = true"><font-awesome-icon icon="external-link-alt" /></li>
        <li title="export md file" v-on:click="downloadMD()"><font-awesome-icon icon="file-export" /></li>
        <li title="copy pot" v-on:click="dupPot"><font-awesome-icon icon="copy" /></li>
        <li title="delete pot" v-on:click="deletePot"><font-awesome-icon icon="trash-alt" /></li>
      </ul>
    </div>
    <GenerateURL v-if="linkmenu" v-model="linkmenu" :pot="pot" :details="details" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Postbox from '@/components/Postbox.vue';
import PotBlock from '@/components/Pot/PotBlock.vue';
import GenerateURL from '@/components/Pot/GenerateURL.vue';
import { uuid } from 'vue-idb'
import dayjs from 'dayjs'
const YAML = require('json-to-pretty-yaml');

export default {
  data() {
    return {
      display: false,
      pot: {},
      description: '',
      details: [],
      linkmenu: false,
      message: false
    }
  },
  components: {
    Postbox,
    PotBlock,
    GenerateURL
  },
  computed: {
  },
  created(){
    if(this.$route.name === 'PotDetail'){
      this.init()
      this.getPot(this.$route.params.id)
      this.getPotDetail(this.$route.params.id)
    }
  },
  watch: {
    '$route' (to) {
      if(to.name === 'PotDetail'){
        this.init()
        this.getPot(to.params.id)
        this.getPotDetail(to.params.id)
      }
    }
  },
  methods: {
    ...mapActions([
      "toggleSpSlide", 'potsAdd', 'potsRemove'
    ]),
    init(){
      this.display = false
      this.pot = [],
      this.description = '',
      this.details = []
    },
    getPot: async function(id){
      this.pot = await this.$db.pots.where({'id': id}).toArray().then((data)=>{ return data[0]})
      this.display = true
    },
    archivePot: async function(id, statusVal){
      let mesPara = {};
      mesPara.icon = 'spinner';

      // console.log(id);
      await this.$db.pots.update(id, {status: statusVal, updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')})
      mesPara.message = 'ローカルDBに保存しました';

      this.display = false
      this.toggleSpSlide(false)
      this.$router.push('/')

      mesPara.message = 'クラウドに保存しています...';
      this.setMessage(mesPara);
      // // GDに同期
      await this.gdApiInit();
      await this.gdCheckSignin();
      if(this.isGdSignin){
        await this.setCloudDataset();
        await this.gdUpload();
      }
      mesPara = false;
      this.setMessage(mesPara);
      this.init()
    },
    getPotDetail: async function(id){
      // console.log('getPotDetail');
      this.details = await this.$db.potDetails.where({potId: id}).sortBy('order').then((data)=>{ return data})
    },
    deletePot: async function(){
      let mesPara = {};
      mesPara.icon = 'spinner';

      await this.potsRemove({'id': this.pot.id}).then(async()=>{
        mesPara.message = 'ローカルDBに保存しました';
        this.setMessage(mesPara);
        this.display = false
        this.toggleSpSlide(false)
        this.$router.push('/')

        mesPara.message = 'クラウドに保存しています...';
        this.setMessage(mesPara);
        // // GDに同期
        await this.gdApiInit();
        await this.gdCheckSignin();
        if(this.isGdSignin){
          await this.setCloudDataset();
          await this.gdUpload();
        }
        mesPara = false;
        this.setMessage(mesPara);
        this.init()
      })
    },
    deletePotDetail: async function(pdId){
      let mesPara = {};
      mesPara.icon = 'spinner';
      await this.$db.potDetails.delete(pdId);
      // potの最終更新も更新する
      await this.$db.pots.update(pdId, {updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')})
      await this.getPotDetail(this.$route.params.id);

      mesPara.message = 'ローカルDBに保存しました';
      this.setMessage(mesPara);

      mesPara.message = 'クラウドに保存しています...';
      this.setMessage(mesPara);
      // // GDに同期
      await this.gdApiInit();
      await this.gdCheckSignin();
      if(this.isGdSignin){
        await this.setCloudDataset();
        await this.gdUpload();
      }
      mesPara = false;
      this.setMessage(mesPara);
    },
    dupPot: async function(){
      const params = {
        id: uuid(),
        title: 'copy of ' + this.pot.title,
        author: this.pot.author,
        status: this.pot.status,
        created_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ') ,
        updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')
      }
      await this.potsAdd(params).then(async ()=>{
        let mesPara = {};
        mesPara.icon = 'spinner';
        mesPara.message = 'ローカルDBに保存しました';
        this.setMessage(mesPara);

        this.$router.push({ name: 'PotDetail', params: {id: params.id}})

        mesPara.message = 'クラウドに保存しています...';
        this.setMessage(mesPara);
        // // GDに同期
        await this.gdApiInit();
        await this.gdCheckSignin();
        if(this.isGdSignin){
          await this.setCloudDataset();
          await this.gdUpload();
        }
        mesPara = false;
        this.setMessage(mesPara);

      })
    },
    downloadMD () {
      let md = '\ufeff---\n' + YAML.stringify(this.pot) + '---\n';

      for(let i in this.details){
        md += '\n' + this.details[i].text + '\n'
      }
      let blob = new Blob([md], { type: 'text/plain' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = this.pot.title + '.md'
      link.click()
    },
    setMessage: async function(val){
      this.message = val;
      const tmp = await this.$db.pots.where({'id': this.$route.params.id}).toArray().then((data)=>{ return data[0]});
      this.pot.updated_at = tmp.updated_at;
    }
  }
}
</script>

<style lang="scss">
  .pot__detail{
    background: #EEE;
    z-index: 9999;
    position: relative;
    width: 100%;
    min-height: 100%;
    height: 100%;
  }
  .pot{
    padding: 12px;
    position: relative;
    height: 100%;
    width: 100%;
    .pot__head{
      padding: 12px;
      position: sticky;
      top: 12px;
      z-index: 1;
      .desciption{
        font-size: .9rem;
        margin-top: 16px;
        color: #808080;
      }
    }
    .pot__content{
      margin: 32px 0 0;
      .pot__block{
        position: relative;
        padding: 16px 0;
        &:after{
          content: '';
          background: #e1e1e1;
          width: 3px;
          height: 100%;
          position: absolute;
          left: 50%;
          top: 0;
          z-index: -1;
        }
        .pot__action{
          min-height: 40px;
          margin-left: 50%;
          position: relative;
          padding-left: 16px;
          font-size: .8rem;
          &:before{
            position: absolute;
            content: '';
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #e1e1e1;
            display: block;
            left: -7px;
          }
        }
        &:first-child{
          padding-top: 0;
        }
        .pot__block--inner{
          overflow: hidden;
          .pot__block--detail{
            p, pre, h2, h3, h4, >div>ul{
              padding: .8rem;
            }
            >div >ul{
              margin-left: 1.3rem;
            }
            >div >ol{
              margin-left: 2rem;
            }
            pre{
              overflow-x: scroll;
              background: #333;
              color: #64f18a;
              font-size: .9rem;
            }
            blockquote{
              background: #f5f5f5;
              font-size: .8rem;
              font-style: italic;
              color: #333;
              padding: 4px 16px;
              position: relative;
              &:before{
                content: '';
                width: 6px;
                height: calc(100% - 24px);
                background: #DEDEDE;
                position: absolute;
                left: 12px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
          .pot__block--edit{
            padding: .8rem;
            background: #FAFAFA;
            textarea{
              width: 100%;
              padding: .8rem;
              &:focus{
                outline: 1px solid #EEE;
              }
            }
          }
          .pot__block--arch{
            width: 100%;
            font-size: .8rem;;
            background: #FAFAFA;
            padding: .8rem;
            color: #AAA;
          }
        }
        .pot__date{
          text-align: right;
          font-size: .8rem;
          margin-top: 8px;
        }
      }
    }
  }
  .pot__btm__box{
    position: absolute;
    width: 100%;
    bottom: 0;
    background: #FFF;
    margin: 0;
    z-index: 9999;
    justify-content: space-between;
    border-top: 1px solid #DDD;
    .pot__menu{
      list-style: none;
      justify-content: flex-end;
      padding: 0 8px;
      li{
        display: inline-block;
        padding: 8px 8px;
        color: #AAA;
        cursor: pointer;
        &:hover{
          color: #666;
        }
      }
    }
    .pot__message{
      font-size: .75rem;
      columns: #666;
      padding: 0 12px;
    }
  }

  @media screen and (max-width: 648px){
    h1{
      font-size: 1.2rem;
    }
    .desciption{
      display: none;
    }
    .pot__block--inner{
      font-size: .9rem;
      >p{
        font-size: .9rem;
      }
      blockquote{
        font-size: .7rem;
      }
    }
  }
</style>
